import { render, staticRenderFns } from "./FormGetShippingMethod.vue?vue&type=template&id=2bb3a2ae&scoped=true&"
import script from "./FormGetShippingMethod.vue?vue&type=script&lang=js&"
export * from "./FormGetShippingMethod.vue?vue&type=script&lang=js&"
import style0 from "./FormGetShippingMethod.vue?vue&type=style&index=0&id=2bb3a2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3a2ae",
  null
  
)

export default component.exports